import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {displayOverlayForFilterSelector} from '../pages/SRP/redux/selectors';
import scrollToTop from '../utils/scrollToTop';

const useScrollToTopOnFilterApiResponse = (scrollPosition = 0) => {
  const displayOverlay = useSelector(displayOverlayForFilterSelector);
  const [didMount, setDidMount] = useState(false);

  /*
  useEffect will get called even on the First mount regardless of 'displayOverlay' 
  value change and displayOverlay being false by default, 
  will trigger the scroll. So in order to skip this scenario I used didmount. 
  Which means scroll will happen only when the value of displayOverlay 
  changes from true to false.
  */
  useEffect(() => {
    if (!didMount) setDidMount(true);
    else if (!displayOverlay && didMount) scrollToTop(scrollPosition, false);
  }, [displayOverlay]);

  return {displayOverlay};
};

export default useScrollToTopOnFilterApiResponse;
